// Fichier de redirection pour la rétrocompatibilité
import ObjectiveBoard from './ObjectiveBoard/index';
export default ObjectiveBoard;